


















































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class MarketingReportBody extends Vue {
  @Prop() readonly data: any;

  @Prop() readonly footer: any;

  @Prop() readonly stage: any;

  @Prop() readonly fetchReportProvider!: Function;

  utilsInstance = utils;

  onClickProviderName(name) {
    this.fetchReportProvider(name);
  }
}
